import { ReactNode } from 'react';
import cn from 'classnames';
import { Outlet } from 'react-router-dom';
import { Tabs as GTabs } from '@geist-ui/core';
import useIsMobile from '../hooks/useIsMobile';

type TLink = {
  to: string;
  name: string;
  active?: boolean;
  labelClassName?: string;
};

interface BreadcrumbsProps {
  tabs: TLink[];
  value?: string;
  children?: ReactNode;
  initialValue?: string;
  handleChange: (value: string) => void;
}

const props = {
  leftSpace: 0,
  hideBorder: true,
  hideDivider: true,
  hoverWidthRatio: 0,
  hoverHeightRatio: 0,
  activeClassName: 'active-item',
};

export default function Tabs({
  tabs,
  value,
  children,
  initialValue,
  handleChange,
}: BreadcrumbsProps) {
  const { isXs } = useIsMobile();

  return (
    <>
      <div className="submenu">
        <div className="container">
          <GTabs
            value={value}
            onChange={handleChange}
            initialValue={initialValue}
            {...props}
            {...(!isXs
              ? {
                  align: 'center',
                }
              : {})}
          >
            {tabs.map(({ to, name, active, labelClassName }) => (
              <GTabs.Item
                key={to}
                disabled={active}
                label={
                  <div className={cn('label', labelClassName)}>{name}</div>
                }
                value={to}
              />
            ))}
          </GTabs>
        </div>
      </div>
      {children || <Outlet />}
    </>
  );
}
